var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg50(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1222 2.85892V8.58423C18.1222 10.0013 17.4769 11.6461 16.3058 13.2157C14.9409 15.0444 12.9304 16.6585 10.4916 17.8837L10.2598 18L10.028 17.8837C7.58922 16.6585 5.57874 15.0444 4.21385 13.2157C3.04271 11.6461 2.39746 10.0013 2.39746 8.58423V2.85892L6.2226 0.170048H14.2971L18.1222 2.85892Z",
    fill: "#00358F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1221 2.85892V8.58423C18.1221 10.0013 17.4769 11.6461 16.3057 13.2157C14.9409 15.0444 12.9304 16.6585 10.4916 17.8837L10.2598 18V0.170048H14.297L18.1221 2.85892Z",
    fill: "#012453"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6437 2.25957H6.87562L4.47314 3.94825V8.58422C4.47314 10.1775 6.03039 13.2909 10.2596 15.6461C14.4889 13.2909 16.0461 10.1775 16.0461 8.58422V3.94825L13.6437 2.25957Z",
    fill: "#FAD261"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0463 3.94825V8.58422C16.0463 10.1775 14.489 13.2909 10.2598 15.6461V2.25957H13.6438L16.0463 3.94825Z",
    fill: "#D69E00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6173 7.93387C11.5594 7.93387 12.323 7.16517 12.323 6.21693C12.323 5.2687 11.5594 4.5 10.6173 4.5C9.67529 4.5 8.91162 5.2687 8.91162 6.21693C8.91162 7.16517 9.67529 7.93387 10.6173 7.93387Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20581 10.681C7.54199 11.2979 8.03505 11.8138 8.6345 12.1759C9.23394 12.5379 9.91822 12.733 10.6172 12.7413C11.3162 12.733 12.0005 12.5379 12.6 12.1759C13.1994 11.8138 13.6925 11.2979 14.0287 10.681C14.0116 9.37884 11.7485 8.62064 10.6172 8.62064C9.47986 8.62064 7.22287 9.37884 7.20581 10.681Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg50);
export default __webpack_public_path__ + "static/media/svg50.80d46609f85b2ac6edc4e9485d5eb4ac.svg";
export { ForwardRef as ReactComponent };